import { render } from "./CancelOrderModal.vue?vue&type=template&id=91d960fc&scoped=true"
import script from "./CancelOrderModal.vue?vue&type=script&lang=js"
export * from "./CancelOrderModal.vue?vue&type=script&lang=js"

import "./CancelOrderModal.vue?vue&type=style&index=0&id=91d960fc&scoped=true&lang=less"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d960fc"]])

export default __exports__